// Custom i18next language detector — prefer the host's
// `currentUser.presenterLanguage` over the browser's `navigator.language`.
// The host knows the user's chosen locale; the browser only knows the user
// agent's preferred display language, which can disagree.

import { getHostLanguage } from "../host/useHostLanguage";
import { toTeamLocale } from "./presenterLang";

interface DetectorModule {
  type: "languageDetector";
  init: () => void;
  detect: () => string | undefined;
  cacheUserLanguage: (lng: string) => void;
}

export const hostLanguageDetector: DetectorModule = {
  type: "languageDetector",
  init: () => {},
  detect: () => {
    // Map the presenter's code to our locale-bundle key (e.g. `pt_BR` -> `br`)
    // so the initial paint resolves the same bundle the runtime switch does.
    const fromHost = toTeamLocale(getHostLanguage());
    if (fromHost) return fromHost;
    if (typeof navigator !== "undefined" && navigator.language) {
      return navigator.language.split("-")[0];
    }
    return "en";
  },
  cacheUserLanguage: () => {},
};
